import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLightningBolt: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="lightning-bolt, speed, thunder, flash, high woltage"><path d="M12.7822 2.46483C13.5944 1.53598 15.174 2.25894 14.9433 3.52343L13.8994 9.24999H17.7636C18.7873 9.2501 19.3766 10.4136 18.7714 11.2392L11.2939 21.4404C10.5093 22.51 8.81863 21.7816 9.05658 20.4766L10.1005 14.75H6.23627C5.21262 14.7499 4.62332 13.5864 5.22845 12.7607L12.706 2.55956L12.7822 2.46483Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLightningBolt;
